var _path, _path2, _path3, _path4, _path5, _path6;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotWinner(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.87891 11.0054C9.20499 11.0054 10.4768 10.4786 11.4144 9.54097C12.3521 8.60328 12.8789 7.33151 12.8789 6.00543",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0505 3.25542C11.643 2.63488 11.1024 2.11287 10.468 1.72729C9.83361 1.34171 9.12131 1.10224 8.38283 1.02626C7.64435 0.950276 6.89821 1.0397 6.19859 1.28802C5.49898 1.53635 4.86344 1.93735 4.33811 2.46192C3.81279 2.98648 3.41087 3.62144 3.16154 4.3207C2.9122 5.01996 2.8217 5.76596 2.89662 6.50455C2.97153 7.24315 3.20998 7.95579 3.59464 8.59074C3.9793 9.22569 4.50053 9.76702 5.12048 10.1754",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87891 5.99542C9.87891 5.59986 9.76161 5.21318 9.54185 4.88428C9.32208 4.55538 9.00973 4.29904 8.64427 4.14766C8.27882 3.99629 7.87669 3.95668 7.48873 4.03385C7.10076 4.11102 6.7444 4.3015 6.46469 4.58121C6.18499 4.86091 5.99451 5.21728 5.91734 5.60524C5.84017 5.9932 5.87977 6.39534 6.03115 6.76079C6.18252 7.12624 6.43887 7.4386 6.76777 7.65836C7.09666 7.87813 7.48334 7.99542 7.87891 7.99542",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8789 10.0054V15.0054L7.87891 13.5054L4.87891 15.0054V13.5754",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48 10.3854L1.75 14.1354",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3505 1.4754L5.48047 10.3854",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotWinner);
export default __webpack_public_path__ + "static/media/not-winner.9ce068d2b2fe65a0c0ee07db7c09bc97.svg";
export { ForwardRef as ReactComponent };